import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/shadows.stylex';
import { shadows } from '@tokens/shadows.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';

// The ledger frame (canvas design 1a). Square corners throughout. (The header's
// green tint is in table.styles.ts `thLedger` — it must live inside a
// `stylex.create` there, not be imported across files.)
export const styles = {
  frame: {
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kaIpWk: "x1xv63ag",
    kWkggS: "x13uruat",
    kVQacm: "xb3r6kr",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    $$css: true
  },
  head: {
    kVQacm: "xb3r6kr",
    kWkggS: "x1v7mt90",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xra1o3",
    $$css: true
  },
  pill: {
    kVAEAm: "x10l6tqk",
    k87sOh: "x1tk7jg1",
    kbCHJM: "x1nrll8i",
    k3aq6I: "xuuh30",
    kY2c9j: "xzkaem6",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1fwedmp",
    kZKoxP: "x10w6t97",
    kg3NbH: "xmmysrq",
    ksu8eU: "xng3xce",
    kaIpWk: "x1d0dq8e",
    kWkggS: "xlvhwkj",
    kMwMTN: "x1m3rtoy",
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    k63SB2: "xtpl1r7",
    kGVxlE: "x7g3v46",
    kkrTdU: "x1ypdohk",
    kI3sdo: "x1a2a7pz xx4dj4q",
    $$css: true
  },
  tail: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    kwnvtZ: "x1a02dak",
    kOIVth: "x1bof9c1",
    kg3NbH: "xb1fagy",
    k8WAf4: "xw2h9tp",
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    kMwMTN: "xdxw5r1",
    k9WMMc: "x2b8uid",
    $$css: true
  },
  tailPaused: {
    kAzted: "xseoqlg",
    kWkggS: "x16vpd03",
    $$css: true
  },
  tailError: {
    kAzted: "x1qafhyn",
    kMwMTN: "x2wi9gy",
    kWkggS: "x8qqj1s",
    $$css: true
  },
  tailEnd: {
    kAzted: "xefclja",
    kXwgrk: "xdt5ytf",
    kOIVth: "xr8clws",
    kWkggS: "x16vpd03",
    $$css: true
  },
  endLabel: {
    kGuDYH: "x34ze3o",
    kb6lSQ: "x11fj6oh",
    kP9fke: "xtvhhri",
    k63SB2: "xtpl1r7",
    kMwMTN: "x1em627c",
    $$css: true
  },
  foot: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kwnvtZ: "x1a02dak",
    k1C7PZ: "x1ox4up4",
    khm7nJ: "x1uxux9d",
    kAzted: "x1wxaq2x",
    kg3NbH: "xb1fagy",
    k8WAf4: "xyggvxn",
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "x1p7xzfl",
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    kMwMTN: "xdxw5r1",
    $$css: true
  },
  footRows: {
    kcqcaj: "xss6m8b",
    k7Eaqz: "xlm99nl x1w9335",
    $$css: true
  },
  footStrong: {
    kMwMTN: "x1oezkus",
    k63SB2: "xtpl1r7",
    $$css: true
  },
  track: {
    kVAEAm: "x1n2onr6",
    kzqmXN: "xq1dxzn",
    kZKoxP: "xuoj239",
    kWkggS: "xv573ff",
    k1xSpc: "x1lliihq xkaaz9w",
    $$css: true
  },
  fill: {
    kVAEAm: "x10l6tqk",
    kYYq5F: "x10no89f",
    kLqNvP: "x1o0tod",
    kWkggS: "xlvhwkj",
    $$css: true
  },
  status: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1fwedmp",
    kMwMTN: "x1em627c",
    $$css: true
  },
  footSpacer: {
    kzQI83: "x1iyjqo2",
    $$css: true
  }
};